
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FamilyWithCategories,
  FunctionalScopeWithLabel,
  IndustryExpertiseWithLabel,
} from '../models';
import {
    FamilyWithCategoriesFromJSON,
    FamilyWithCategoriesToJSON,
    FunctionalScopeWithLabelFromJSON,
    FunctionalScopeWithLabelToJSON,
    IndustryExpertiseWithLabelFromJSON,
    IndustryExpertiseWithLabelToJSON,
} from '../models';

export interface GetFreeSkillSuggestionsRequest {
    query: string;
}

/**
 * 
 */
export class OntologyReadsApi extends runtime.BaseAPI {

    /**
     * Obtain all functional skills
          */
    async getAllFunctionalSkillsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FunctionalScopeWithLabel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FunctionalScopeWithLabel>>({
            path: `/brief/api/ontology/functional-scopes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FunctionalScopeWithLabelFromJSON);
        return response;
    }

    /**
     * Obtain all functional skills
          */
    async getAllFunctionalSkills(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FunctionalScopeWithLabel>> {
        const response = await this.getAllFunctionalSkillsRaw(initOverrides);
        return response._data;
    }

    /**
     * Obtain every possible industry expertise code
          */
    async getAllIndustryExpertisesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<IndustryExpertiseWithLabel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<IndustryExpertiseWithLabel>>({
            path: `/brief/api/ontology/industry-expertises`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(IndustryExpertiseWithLabelFromJSON);
        return response;
    }

    /**
     * Obtain every possible industry expertise code
          */
    async getAllIndustryExpertises(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<IndustryExpertiseWithLabel>> {
        const response = await this.getAllIndustryExpertisesRaw(initOverrides);
        return response._data;
    }

    /**
     * Obtain every possible free skills
          */
    async getFreeSkillSuggestionsRaw(requestParameters: GetFreeSkillSuggestionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<string>>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling getFreeSkillSuggestions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<string>>({
            path: `/brief/api/ontology/free-skills-suggestions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Obtain every possible free skills
          */
    async getFreeSkillSuggestions(requestParameters: GetFreeSkillSuggestionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getFreeSkillSuggestionsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List all families with categories
          */
    async listFamiliesWithCategoriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FamilyWithCategories>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FamilyWithCategories>>({
            path: `/brief/api/ontology/families`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FamilyWithCategoriesFromJSON);
        return response;
    }

    /**
     * List all families with categories
          */
    async listFamiliesWithCategories(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FamilyWithCategories>> {
        const response = await this.listFamiliesWithCategoriesRaw(initOverrides);
        return response._data;
    }

}
